{
  "_format": "hh-sol-artifact-1",
  "contractName": "ServiceConfigurationV5",
  "sourceName": "contracts/ServiceConfigurationV5.sol",
  "abi": [
    {
      "inputs": [],
      "name": "UpgradeRevert",
      "type": "error"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "bytes32",
          "name": "which",
          "type": "bytes32"
        },
        {
          "indexed": false,
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "AddressSet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "address",
          "name": "previousAdmin",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "address",
          "name": "newAdmin",
          "type": "address"
        }
      ],
      "name": "AdminChanged",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "beacon",
          "type": "address"
        }
      ],
      "name": "BeaconUpgraded",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "version",
          "type": "uint8"
        }
      ],
      "name": "Initialized",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "address",
          "name": "addr",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "bool",
          "name": "value",
          "type": "bool"
        }
      ],
      "name": "LiquidityAssetSet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "factory",
          "type": "address"
        }
      ],
      "name": "LoanFactorySet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "factory",
          "type": "address"
        }
      ],
      "name": "LoanLibSet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "value",
          "type": "uint256"
        }
      ],
      "name": "ParameterSet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "factory",
          "type": "address"
        }
      ],
      "name": "PoolAdminWalletSet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "factory",
          "type": "address"
        }
      ],
      "name": "PoolFactoryDynamicSet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "factory",
          "type": "address"
        }
      ],
      "name": "PoolFactoryFlexSet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "factory",
          "type": "address"
        }
      ],
      "name": "PoolFactorySet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "factory",
          "type": "address"
        }
      ],
      "name": "PoolLibFlexSet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "factory",
          "type": "address"
        }
      ],
      "name": "PoolLibSet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "factory",
          "type": "address"
        }
      ],
      "name": "PoolRegistrySet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "bool",
          "name": "paused",
          "type": "bool"
        }
      ],
      "name": "ProtocolPaused",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "factory",
          "type": "address"
        }
      ],
      "name": "QueryLibSet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "previousAdminRole",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "newAdminRole",
          "type": "bytes32"
        }
      ],
      "name": "RoleAdminChanged",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "sender",
          "type": "address"
        }
      ],
      "name": "RoleGranted",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "sender",
          "type": "address"
        }
      ],
      "name": "RoleRevoked",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "registry",
          "type": "address"
        }
      ],
      "name": "TermsOfServiceRegistrySet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "implementation",
          "type": "address"
        }
      ],
      "name": "Upgraded",
      "type": "event"
    },
    {
      "inputs": [],
      "name": "AUTOMATION_ROLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "BORROWER_ROLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "DEFAULT_ADMIN_ROLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "DEPLOYER_ROLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "FEE_COLLECTOR",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "FIAT_GATEWAY",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "OPERATOR_ROLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "PAUSER_ROLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "POOL_ADMIN_ROLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getLegacyFactories",
      "outputs": [
        {
          "components": [
            {
              "internalType": "enum IFactoryType",
              "name": "factoryType",
              "type": "uint8"
            },
            {
              "internalType": "address",
              "name": "factoryAddress",
              "type": "address"
            }
          ],
          "internalType": "struct LegacyFactoryStruct[]",
          "name": "",
          "type": "tuple[]"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getLoanFactory",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getLoanLib",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getPoolAdminWallet",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getPoolFactory",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getPoolFactoryDynamic",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getPoolFactoryFlex",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getPoolLib",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getPoolLibFlex",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getPoolRegistry",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getQueryLib",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        }
      ],
      "name": "getRoleAdmin",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getServiceAddressList",
      "outputs": [
        {
          "components": [
            {
              "internalType": "address[]",
              "name": "liquidityAssets",
              "type": "address[]"
            },
            {
              "internalType": "address",
              "name": "tosAcceptanceRegistry",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "loanFactory",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolFactoryAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "queryLibAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolLibAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "loanLibAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolControllerFactoryAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "withdrawControllerFactoryAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "vaultFactoryAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolAccessControlFactoryAddress",
              "type": "address"
            }
          ],
          "internalType": "struct SerivceAddressList",
          "name": "addressList",
          "type": "tuple"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getServiceAddressListV3",
      "outputs": [
        {
          "components": [
            {
              "internalType": "address[]",
              "name": "liquidityAssets",
              "type": "address[]"
            },
            {
              "internalType": "address",
              "name": "tosAcceptanceRegistry",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "loanFactory",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolFactoryAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolFactoryFlexAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "queryLibAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolLibAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolLibFlexAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "loanLibAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolControllerFactoryAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "withdrawControllerFactoryAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "vaultFactoryAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolAccessControlFactoryAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolControllerFactoryFlexAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "withdrawDepositControllerFactoryFlexAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolRegistryAddress",
              "type": "address"
            }
          ],
          "internalType": "struct SerivceAddressListV3",
          "name": "setLoanFactoryerivceAddressList",
          "type": "tuple"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getServiceAddressListV5",
      "outputs": [
        {
          "components": [
            {
              "internalType": "address[]",
              "name": "liquidityAssets",
              "type": "address[]"
            },
            {
              "internalType": "address",
              "name": "tosAcceptanceRegistry",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "loanFactory",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolFactoryAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolFactoryFlexAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "queryLibAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolLibAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolLibFlexAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "loanLibAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolControllerFactoryAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "withdrawControllerFactoryAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "vaultFactoryAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolAccessControlFactoryAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolControllerFactoryFlexAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "withdrawDepositControllerFactoryFlexAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolRegistryAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolFactoryDynamicAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolControllerFactoryDynamicAddress",
              "type": "address"
            }
          ],
          "internalType": "struct SerivceAddressListV5",
          "name": "setLoanFactoryerivceAddressList",
          "type": "tuple"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "grantRole",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "hasRole",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "initialize",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "isAutomation",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "isBorrower",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "isDeployer",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "isFeeCollector",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "isFiatGateway",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "name": "isLiquidityAsset",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "isOperator",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "isPoolAdmin",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "legacyFactories",
      "outputs": [
        {
          "internalType": "enum IFactoryType",
          "name": "factoryType",
          "type": "uint8"
        },
        {
          "internalType": "address",
          "name": "factoryAddress",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "liquidityAssetKeys",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "loanFactory",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "loanLib",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "paused",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "poolAdminWallet",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "poolFactory",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "poolFactoryDynamic",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "poolFactoryFlex",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "poolLib",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "poolLibFlex",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "poolRegistry",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "proxiableUUID",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "queryLib",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "renounceRole",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "revokeRole",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        },
        {
          "internalType": "bool",
          "name": "value",
          "type": "bool"
        }
      ],
      "name": "setLiquidityAsset",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "setLoanFactory",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "setLoanLib",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bool",
          "name": "paused_",
          "type": "bool"
        }
      ],
      "name": "setPaused",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "setPoolAdminWallet",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "setPoolFactory",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "setPoolFactoryDynamic",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "setPoolFactoryFlex",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "setPoolLib",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "setPoolLibFlex",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "setPoolRegistry",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "setQueryLib",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "setToSAcceptanceRegistry",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes4",
          "name": "interfaceId",
          "type": "bytes4"
        }
      ],
      "name": "supportsInterface",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "tosAcceptanceRegistry",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "newImplementation",
          "type": "address"
        }
      ],
      "name": "upgradeTo",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "newImplementation",
          "type": "address"
        },
        {
          "internalType": "bytes",
          "name": "data",
          "type": "bytes"
        }
      ],
      "name": "upgradeToAndCall",
      "outputs": [],
      "stateMutability": "payable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "version",
      "outputs": [
        {
          "internalType": "uint16",
          "name": "",
          "type": "uint16"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    }
  ],
  "bytecode": "0x60a0604052306080523480156200001557600080fd5b506200002062000026565b620000e7565b600054610100900460ff1615620000935760405162461bcd60e51b815260206004820152602760248201527f496e697469616c697a61626c653a20636f6e747261637420697320696e697469604482015266616c697a696e6760c81b606482015260840160405180910390fd5b60005460ff90811614620000e5576000805460ff191660ff9081179091556040519081527f7f26b83ff96e1f2b6a682f133852f6798a09c465da95921460cefb38474024989060200160405180910390a15b565b608051613b626200011f60003960008181611064015281816110a4015281816118b1015281816118f101526119830152613b626000f3fe6080604052600436106103195760003560e01c80636d70f7ae116101a35780636d70f7ae146107795780636e7e09b81461079957806374a09f2c146107b95780637a7e3261146107d75780637a9bd5e4146107f65780637b77cd6a146108155780637bcc269e146108355780637bd3818a146108555780637be53ca1146108755780637f660b01146108955780637fbc9b35146108b75780638129fc1c146108d657806386a31998146108eb57806391d148541461090b578063943d35791461092b578063a217fddf1461094d578063a96966f714610962578063afcff50f14610983578063b37ed8cd146109a4578063b8f6dba7146109c4578063c117fa3b146109e6578063cf2ab44914610a08578063d08ddce014610a2a578063d547741f14610a4a578063d7b78d7c14610a6a578063d80dfbf514610a8b578063d9ca509614610aac578063e378df1b14610acc578063e5d9dc3614610afa578063e633ea7314610b1a578063e63ab1e914610b4a578063eaf6e48314610b6c578063ecd0026114610b8c578063f5b541a614610bae578063fb0821d214610bd057600080fd5b80625049571461031e57806301ffc9a71461035357806306230bc51461037357806306b63b0d1461039b5780630bc732db146103ba5780630e7b949e146103db5780630e9c07261461040b57806310764ee51461042d57806316c38b3c1461044c57806317d997651461046c5780631a7626441461048d578063248a9ca3146104ac57806324c20eec146104cc5780632d15ef6d146104ee5780632daa0d891461050e5780632f2ff15d1461052e57806336568abe1461054e5780633659cfe61461056e57806339d1fcb51461058e5780633b90b9bf146105ad5780633f999ae1146105cd5780633fd2f2ae146105ef5780634219dc401461060f578063425cd62a14610630578063473597a0146106515780634e4c182f146106715780634f1ef2861461069157806350c358a4146106a457806352d1902d146106c457806354fd4d50146106d957806358faf397146106f65780635c975abb14610717578063620543a0146107385780636bd969b31461075a575b600080fd5b34801561032a57600080fd5b5061033e6103393660046130d6565b610bf0565b60405190151581526020015b60405180910390f35b34801561035f57600080fd5b5061033e61036e3660046130f3565b610c10565b34801561037f57600080fd5b50610106546001600160a01b03165b60405161034a919061312a565b3480156103a757600080fd5b50610107546001600160a01b031661038e565b3480156103c657600080fd5b506101075461038e906001600160a01b031681565b3480156103e757600080fd5b506103fd6000805160206139a683398151915281565b60405190815260200161034a565b34801561041757600080fd5b5061042b6104263660046130d6565b610c45565b005b34801561043957600080fd5b50610109546001600160a01b031661038e565b34801561045857600080fd5b5061042b61046736600461314c565b610d70565b34801561047857600080fd5b506101025461038e906001600160a01b031681565b34801561049957600080fd5b50610102546001600160a01b031661038e565b3480156104b857600080fd5b506103fd6104c7366004613169565b610e33565b3480156104d857600080fd5b506103fd600080516020613aed83398151915281565b3480156104fa57600080fd5b5061042b6105093660046130d6565b610e48565b34801561051a57600080fd5b5061042b610529366004613182565b610ec7565b34801561053a57600080fd5b5061042b6105493660046131bb565b610fbb565b34801561055a57600080fd5b5061042b6105693660046131bb565b610fdc565b34801561057a57600080fd5b5061042b6105893660046130d6565b61105a565b34801561059a57600080fd5b50610104546001600160a01b031661038e565b3480156105b957600080fd5b5061033e6105c83660046130d6565b611122565b3480156105d957600080fd5b506105e261113c565b60405161034a9190613224565b3480156105fb57600080fd5b5061038e61060a366004613169565b6116dc565b34801561061b57600080fd5b506101005461038e906001600160a01b031681565b34801561063c57600080fd5b506101065461038e906001600160a01b031681565b34801561065d57600080fd5b5061042b61066c3660046130d6565b611706565b34801561067d57600080fd5b5061042b61068c3660046130d6565b611828565b61042b61069f3660046133b0565b6118a7565b3480156106b057600080fd5b5061033e6106bf3660046130d6565b61195c565b3480156106d057600080fd5b506103fd611976565b3480156106e557600080fd5b50604051610101815260200161034a565b34801561070257600080fd5b506101015461038e906001600160a01b031681565b34801561072357600080fd5b5060fb5461033e90600160a01b900460ff1681565b34801561074457600080fd5b5061074d611a24565b60405161034a91906134ab565b34801561076657600080fd5b50610100546001600160a01b031661038e565b34801561078557600080fd5b5061033e6107943660046130d6565b611ac1565b3480156107a557600080fd5b5061042b6107b43660046130d6565b611adb565b3480156107c557600080fd5b5060ff546001600160a01b031661038e565b3480156107e357600080fd5b50610103546001600160a01b031661038e565b34801561080257600080fd5b50610105546001600160a01b031661038e565b34801561082157600080fd5b5061042b6108303660046130d6565b611b5a565b34801561084157600080fd5b5061042b6108503660046130d6565b611bd9565b34801561086157600080fd5b5061042b6108703660046130d6565b611c57565b34801561088157600080fd5b5061033e6108903660046130d6565b611d79565b3480156108a157600080fd5b506103fd600080516020613b0d83398151915281565b3480156108c357600080fd5b50610101546001600160a01b031661038e565b3480156108e257600080fd5b5061042b611d93565b3480156108f757600080fd5b5061042b6109063660046130d6565b611eb9565b34801561091757600080fd5b5061033e6109263660046131bb565b611fd7565b34801561093757600080fd5b50610940612002565b60405161034a919061350a565b34801561095957600080fd5b506103fd600081565b34801561096e57600080fd5b506101035461038e906001600160a01b031681565b34801561098f57600080fd5b506101055461038e906001600160a01b031681565b3480156109b057600080fd5b5060ff5461038e906001600160a01b031681565b3480156109d057600080fd5b506103fd60008051602061398683398151915281565b3480156109f257600080fd5b506109fb612317565b60405161034a91906135d9565b348015610a1457600080fd5b506103fd6000805160206139c683398151915281565b348015610a3657600080fd5b5061042b610a453660046130d6565b6127aa565b348015610a5657600080fd5b5061042b610a653660046131bb565b612829565b348015610a7657600080fd5b506101095461038e906001600160a01b031681565b348015610a9757600080fd5b506101045461038e906001600160a01b031681565b348015610ab857600080fd5b5060fe5461038e906001600160a01b031681565b348015610ad857600080fd5b50610aec610ae7366004613169565b612845565b60405161034a92919061370c565b348015610b0657600080fd5b5061033e610b153660046130d6565b612879565b348015610b2657600080fd5b5061033e610b353660046130d6565b60fc6020526000908152604090205460ff1681565b348015610b5657600080fd5b506103fd600080516020613a8683398151915281565b348015610b7857600080fd5b5061033e610b873660046130d6565b612893565b348015610b9857600080fd5b506103fd600080516020613a2683398151915281565b348015610bba57600080fd5b506103fd600080516020613a6683398151915281565b348015610bdc57600080fd5b5061042b610beb3660046130d6565b6128ad565b6000610c0a600080516020613aed83398151915283611fd7565b92915050565b60006001600160e01b03198216637965db0b60e01b1480610c0a57506301ffc9a760e01b6001600160e01b0319831614610c0a565b610c5d600080516020613a6683398151915233611fd7565b610c825760405162461bcd60e51b8152600401610c7990613732565b60405180910390fd5b610109546001600160a01b031615610d255760408051808201909152600a8152610109546001600160a01b031660208201526101088054600180820183556000929092528251600080516020613acd83398151915290910180549092839160ff19169083600b811115610cf757610cf7613473565b02179055506020919091015181546001600160a01b0390911661010002610100600160a81b03199091161790555b61010980546001600160a01b0319166001600160a01b0383169081179091556040517ff544b1b4ea10794a5a7ebda67894961c6bcedc7d7ee7378b6b3b10f63ff3884c90600090a250565b610d88600080516020613a8683398151915233611fd7565b610dd75760405162461bcd60e51b815260206004820152602c60248201526000805160206139e683398151915260448201526b3737ba1030903830bab9b2b960a11b6064820152608401610c79565b60fb805460ff60a01b1916600160a01b8315158102919091179182905560405160ff9190920416151581527f6e0cb5fa7a57c38eb7939c1104f95fccb5b7a6a8c1a7cab76934305439b639f5906020015b60405180910390a150565b60009081526065602052604090206001015490565b610e60600080516020613a6683398151915233611fd7565b610e7c5760405162461bcd60e51b8152600401610c7990613732565b61010780546001600160a01b0319166001600160a01b0383169081179091556040517f544e7196dfeecc1584160b0d883709b86b955946f4e9bd58a73d67ca58c366cd90600090a250565b610edf600080516020613a6683398151915233611fd7565b610efb5760405162461bcd60e51b8152600401610c7990613732565b6001600160a01b038216600090815260fc60205260409020805460ff19168215801591909117909155610f745760fd80546001810182556000919091527f9346ac6dd7de6b96975fec380d4d994c4c12e6a8897544f22915316cc6cca2800180546001600160a01b0319166001600160a01b0384161790555b604080516001600160a01b038416815282151560208201527f4ae949b1aaebb94eb11fcdbe6523934fa4049b8edb434b1e72f7e446b6ddf466910160405180910390a15050565b610fc482610e33565b610fcd8161292c565b610fd78383612936565b505050565b6001600160a01b038116331461104c5760405162461bcd60e51b815260206004820152602f60248201527f416363657373436f6e74726f6c3a2063616e206f6e6c792072656e6f756e636560448201526e103937b632b9903337b91039b2b63360891b6064820152608401610c79565b61105682826129bc565b5050565b6001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001630036110a25760405162461bcd60e51b8152600401610c799061376f565b7f00000000000000000000000000000000000000000000000000000000000000006001600160a01b03166110d4612a23565b6001600160a01b0316146110fa5760405162461bcd60e51b8152600401610c79906137a9565b61110381612a3f565b6040805160008082526020820190925261111f91839190612af4565b50565b6000610c0a600080516020613b0d83398151915283611fd7565b6040805161024081018252606080825260006020830181905292820183905281018290526080810182905260a0810182905260c0810182905260e08101829052610100810182905261012081018290526101408101829052610160810182905261018081018290526101a081018290526101c081018290526101e081018290526102008101829052610220810191909152610106546000906001600160a01b03161561125d5761010660009054906101000a90046001600160a01b03166001600160a01b031663c5a27c2b6040518163ffffffff1660e01b8152600401602060405180830381865afa158015611236573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061125a91906137e3565b90505b610106546000906001600160a01b0316156112ed5761010660009054906101000a90046001600160a01b03166001600160a01b03166342f6cd1b6040518163ffffffff1660e01b8152600401602060405180830381865afa1580156112c6573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906112ea91906137e3565b90505b610109546000906001600160a01b03161561137d5761010960009054906101000a90046001600160a01b03166001600160a01b0316630a9a6fbd6040518163ffffffff1660e01b8152600401602060405180830381865afa158015611356573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061137a91906137e3565b90505b610100546000906001600160a01b03161561140d5761010060009054906101000a90046001600160a01b03166001600160a01b031663dbf07b186040518163ffffffff1660e01b8152600401602060405180830381865afa1580156113e6573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061140a91906137e3565b90505b610100546000906001600160a01b03161561149d5761010060009054906101000a90046001600160a01b03166001600160a01b031663886ce4046040518163ffffffff1660e01b8152600401602060405180830381865afa158015611476573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061149a91906137e3565b90505b610100546000906001600160a01b03161561152d5761010060009054906101000a90046001600160a01b03166001600160a01b03166318bcb2846040518163ffffffff1660e01b8152600401602060405180830381865afa158015611506573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061152a91906137e3565b90505b610100546000906001600160a01b0316156115bd5761010060009054906101000a90046001600160a01b03166001600160a01b031663f3c517886040518163ffffffff1660e01b8152600401602060405180830381865afa158015611596573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906115ba91906137e3565b90505b6040805160fd8054610260602082028401810190945261024083018181529293849392919084018282801561161b57602002820191906000526020600020905b81546001600160a01b031681526001909101906020018083116115fd575b505050918352505060fe546001600160a01b03908116602083015260ff5481166040830152610100805482166060840152610106548216608084015261010154821660a084015261010354821660c084015261010754821660e08401526101025482169083015295861661012082015293851661014085015291841661016084015283166101808301529482166101a08201529281166101c08401526101055481166101e08401526101095481166102008401521661022090910152919050565b60fd81815481106116ec57600080fd5b6000918252602090912001546001600160a01b0316905081565b61171e600080516020613a6683398151915233611fd7565b61173a5760405162461bcd60e51b8152600401610c7990613732565b610100546001600160a01b0316156117dd57604080518082019091526000808252610100546001600160a01b03166020830152610108805460018082018355919092528251600080516020613acd8339815191529092018054909291839160ff19169083600b8111156117af576117af613473565b02179055506020919091015181546001600160a01b0390911661010002610100600160a81b03199091161790555b61010080546001600160a01b0319166001600160a01b0383169081179091556040517fcc26a9842bf398b87d3fbaaca69d27e087a9e70d9bffce9c4691461fbc30669090600090a250565b611840600080516020613a6683398151915233611fd7565b61185c5760405162461bcd60e51b8152600401610c7990613732565b61010280546001600160a01b0319166001600160a01b0383169081179091556040517fc5e4a0a09e58322f2307e3ca893d214d72f95a491cfe0a7119f746e286ce16bb90600090a250565b6001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001630036118ef5760405162461bcd60e51b8152600401610c799061376f565b7f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316611921612a23565b6001600160a01b0316146119475760405162461bcd60e51b8152600401610c79906137a9565b61195082612a3f565b61105682826001612af4565b6000610c0a600080516020613a2683398151915283611fd7565b6000306001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001614611a115760405162461bcd60e51b815260206004820152603860248201527f555550535570677261646561626c653a206d757374206e6f742062652063616c6044820152771b1959081d1a1c9bdd59da0819195b1959d85d1958d85b1b60421b6064820152608401610c79565b50600080516020613a4683398151915290565b6060610108805480602002602001604051908101604052809291908181526020016000905b82821015611ab857600084815260209020604080518082019091529083018054829060ff16600b811115611a7f57611a7f613473565b600b811115611a9057611a90613473565b8152905461010090046001600160a01b03166020918201529082526001929092019101611a49565b50505050905090565b6000610c0a600080516020613a6683398151915283611fd7565b611af3600080516020613a6683398151915233611fd7565b611b0f5760405162461bcd60e51b8152600401610c7990613732565b61010480546001600160a01b0319166001600160a01b0383169081179091556040517fbd62c73c039f4fd296545c1ade8d4d885db235cf08539102ad8c4a5dc6b3001990600090a250565b611b72600080516020613a6683398151915233611fd7565b611b8e5760405162461bcd60e51b8152600401610c7990613732565b61010580546001600160a01b0319166001600160a01b0383169081179091556040517fd63daa75c27e40358d8dadaebf7cd68c1b0df32fc4a593abcbcda2232ba0bfe790600090a250565b611bf1600080516020613a6683398151915233611fd7565b611c0d5760405162461bcd60e51b8152600401610c7990613732565b60fe80546001600160a01b0319166001600160a01b0383169081179091556040517f553a72947fcd844ec57d7e074a83aee114daad5ea62b25866261cb15ebd8aed590600090a250565b611c6f600080516020613a6683398151915233611fd7565b611c8b5760405162461bcd60e51b8152600401610c7990613732565b610106546001600160a01b031615611d2e576040805180820190915260038152610106546001600160a01b031660208201526101088054600180820183556000929092528251600080516020613acd83398151915290910180549092839160ff19169083600b811115611d0057611d00613473565b02179055506020919091015181546001600160a01b0390911661010002610100600160a81b03199091161790555b61010680546001600160a01b0319166001600160a01b0383169081179091556040517f23d025dc10ab0ed40ab1531b151cb2bdc0af2672d4ded9593c1ea8a20808f2b790600090a250565b6000610c0a60008051602061398683398151915283611fd7565b600054610100900460ff1615808015611db35750600054600160ff909116105b80611dd45750611dc230612c5f565b158015611dd4575060005460ff166001145b611e375760405162461bcd60e51b815260206004820152602e60248201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160448201526d191e481a5b9a5d1a585b1a5e995960921b6064820152608401610c79565b6000805460ff191660011790558015611e5a576000805461ff0019166101001790555b60fb80546001600160a81b03191630179055611e77600033612936565b801561111f576000805461ff0019169055604051600181527f7f26b83ff96e1f2b6a682f133852f6798a09c465da95921460cefb384740249890602001610e28565b611ed1600080516020613a6683398151915233611fd7565b611eed5760405162461bcd60e51b8152600401610c7990613732565b60ff546001600160a01b031615611f8d5760408051808201909152600180825260ff546001600160a01b03166020830152610108805480830182556000919091528251600080516020613acd83398151915290910180549092839160ff19169083600b811115611f5f57611f5f613473565b02179055506020919091015181546001600160a01b0390911661010002610100600160a81b03199091161790555b60ff80546001600160a01b0319166001600160a01b0383169081179091556040517f1759f996980a684917a1bd4a10b8d301d8b404a948aa7805438b4fb185a850dc90600090a250565b60009182526065602090815260408084206001600160a01b0393909316845291905290205460ff1690565b6040805161016081018252606080825260006020830181905292820183905281018290526080810182905260a0810182905260c0810182905260e08101829052610100810182905261012081018290526101408101919091526040805160fd805461018060208202840181019094526101608301818152929384939291908401828280156120b957602002820191906000526020600020905b81546001600160a01b0316815260019091019060200180831161209b575b505050918352505060fe546001600160a01b0390811660208084019190915260ff54821660408085019190915261010054831660608501819052610101548416608086015261010354841660a08601526101025490931660c08501528051631b7e0f6360e31b8152905160e09094019363dbf07b18926004808401939192918290030181865afa158015612151573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061217591906137e3565b6001600160a01b0316815260200161010060009054906101000a90046001600160a01b03166001600160a01b031663886ce4046040518163ffffffff1660e01b8152600401602060405180830381865afa1580156121d7573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906121fb91906137e3565b6001600160a01b0316815260200161010060009054906101000a90046001600160a01b03166001600160a01b03166318bcb2846040518163ffffffff1660e01b8152600401602060405180830381865afa15801561225d573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061228191906137e3565b6001600160a01b0316815260200161010060009054906101000a90046001600160a01b03166001600160a01b031663f3c517886040518163ffffffff1660e01b8152600401602060405180830381865afa1580156122e3573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061230791906137e3565b6001600160a01b03169052919050565b6040805161020081018252606080825260006020830181905292820183905281018290526080810182905260a0810182905260c0810182905260e08101829052610100810182905261012081018290526101408101829052610160810182905261018081018290526101a081018290526101c081018290526101e0810191909152610106546000906001600160a01b0316156124285761010660009054906101000a90046001600160a01b03166001600160a01b031663c5a27c2b6040518163ffffffff1660e01b8152600401602060405180830381865afa158015612401573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061242591906137e3565b90505b610106546000906001600160a01b0316156124b85761010660009054906101000a90046001600160a01b03166001600160a01b03166342f6cd1b6040518163ffffffff1660e01b8152600401602060405180830381865afa158015612491573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906124b591906137e3565b90505b6040805160fd8054610220602082028401810190945261020083018181529293849392919084018282801561251657602002820191906000526020600020905b81546001600160a01b031681526001909101906020018083116124f8575b505050918352505060fe546001600160a01b0390811660208084019190915260ff5482166040808501919091526101008054841660608601819052610106548516608087015261010154851660a087015261010354851660c087015261010754851660e087015261010254909416908501528051631b7e0f6360e31b815290516101209094019363dbf07b18926004808401939192918290030181865afa1580156125c5573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906125e991906137e3565b6001600160a01b0316815260200161010060009054906101000a90046001600160a01b03166001600160a01b031663886ce4046040518163ffffffff1660e01b8152600401602060405180830381865afa15801561264b573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061266f91906137e3565b6001600160a01b0316815260200161010060009054906101000a90046001600160a01b03166001600160a01b03166318bcb2846040518163ffffffff1660e01b8152600401602060405180830381865afa1580156126d1573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906126f591906137e3565b6001600160a01b0316815260200161010060009054906101000a90046001600160a01b03166001600160a01b031663f3c517886040518163ffffffff1660e01b8152600401602060405180830381865afa158015612757573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061277b91906137e3565b6001600160a01b0390811682529384166020820152918316604083015261010554909216606090910152919050565b6127c2600080516020613a6683398151915233611fd7565b6127de5760405162461bcd60e51b8152600401610c7990613732565b61010180546001600160a01b0319166001600160a01b0383169081179091556040517f1566c61eaa9504ad22a593299168b8da957ac8a24c634c583ee8c960e9c12a5c90600090a250565b61283282610e33565b61283b8161292c565b610fd783836129bc565b610108818154811061285657600080fd5b60009182526020909120015460ff8116915061010090046001600160a01b031682565b6000610c0a6000805160206139c683398151915283611fd7565b6000610c0a6000805160206139a683398151915283611fd7565b6128c5600080516020613a6683398151915233611fd7565b6128e15760405162461bcd60e51b8152600401610c7990613732565b61010380546001600160a01b0319166001600160a01b0383169081179091556040517f667b9aa26c967efba858d969dff20019df6fc09bdb33e36182e36ae620ce826d90600090a250565b61111f8133612c6e565b6129408282611fd7565b6110565760008281526065602090815260408083206001600160a01b03851684529091529020805460ff191660011790556129783390565b6001600160a01b0316816001600160a01b0316837f2f8788117e7eff1d82e926ec794901d17c78024a50270940304540a733656f0d60405160405180910390a45050565b6129c68282611fd7565b156110565760008281526065602090815260408083206001600160a01b0385168085529252808320805460ff1916905551339285917ff6391f5c32d9c69d2a47ea670b442974b53935d1edc7fd64eb21e047a839171b9190a45050565b600080516020613a46833981519152546001600160a01b031690565b60fb54604051631430d62960e21b81526001600160a01b03909116906350c358a490612a6f90339060040161312a565b602060405180830381865afa158015612a8c573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612ab09190613800565b61111f5760405162461bcd60e51b8152602060048201526015602482015274155c19dc9859194e881d5b985d5d1a1bdc9a5e9959605a1b6044820152606401610c79565b7f4910fdfa16fed3260ed0e7147f7cc6da11a60208b5b9406d12a635614ffd91435460ff1615612b2757610fd783612cc7565b826001600160a01b03166352d1902d6040518163ffffffff1660e01b8152600401602060405180830381865afa925050508015612b81575060408051601f3d908101601f19168201909252612b7e9181019061381d565b60015b612be45760405162461bcd60e51b815260206004820152602e60248201527f45524331393637557067726164653a206e657720696d706c656d656e7461746960448201526d6f6e206973206e6f74205555505360901b6064820152608401610c79565b600080516020613a468339815191528114612c535760405162461bcd60e51b815260206004820152602960248201527f45524331393637557067726164653a20756e737570706f727465642070726f786044820152681a58589b195555525160ba1b6064820152608401610c79565b50610fd7838383612d61565b6001600160a01b03163b151590565b612c788282611fd7565b61105657612c8581612d8c565b612c90836020612d9e565b604051602001612ca192919061385a565b60408051601f198184030181529082905262461bcd60e51b8252610c79916004016138c9565b612cd081612c5f565b612d325760405162461bcd60e51b815260206004820152602d60248201527f455243313936373a206e657720696d706c656d656e746174696f6e206973206e60448201526c1bdd08184818dbdb9d1c9858dd609a1b6064820152608401610c79565b600080516020613a4683398151915280546001600160a01b0319166001600160a01b0392909216919091179055565b612d6a83612f40565b600082511180612d775750805b15610fd757612d868383612f80565b50505050565b6060610c0a6001600160a01b03831660145b60606000612dad836002613912565b612db8906002613929565b6001600160401b03811115612dcf57612dcf61339a565b6040519080825280601f01601f191660200182016040528015612df9576020820181803683370190505b509050600360fc1b81600081518110612e1457612e1461393c565b60200101906001600160f81b031916908160001a905350600f60fb1b81600181518110612e4357612e4361393c565b60200101906001600160f81b031916908160001a9053506000612e67846002613912565b612e72906001613929565b90505b6001811115612eea576f181899199a1a9b1b9c1cb0b131b232b360811b85600f1660108110612ea657612ea661393c565b1a60f81b828281518110612ebc57612ebc61393c565b60200101906001600160f81b031916908160001a90535060049490941c93612ee381613952565b9050612e75565b508315612f395760405162461bcd60e51b815260206004820181905260248201527f537472696e67733a20686578206c656e67746820696e73756666696369656e746044820152606401610c79565b9392505050565b612f4981612cc7565b6040516001600160a01b038216907fbc7cd75a20ee27fd9adebab32041f755214dbc6bffa90cc0225b39da2e5c2d3b90600090a250565b6060612f398383604051806060016040528060278152602001613aa6602791396060600080856001600160a01b031685604051612fbd9190613969565b600060405180830381855af49150503d8060008114612ff8576040519150601f19603f3d011682016040523d82523d6000602084013e612ffd565b606091505b509150915061300e86838387613018565b9695505050505050565b6060831561308557825160000361307e5761303285612c5f565b61307e5760405162461bcd60e51b815260206004820152601d60248201527f416464726573733a2063616c6c20746f206e6f6e2d636f6e74726163740000006044820152606401610c79565b508161308f565b61308f8383613097565b949350505050565b8151156130a75781518083602001fd5b8060405162461bcd60e51b8152600401610c7991906138c9565b6001600160a01b038116811461111f57600080fd5b6000602082840312156130e857600080fd5b8135612f39816130c1565b60006020828403121561310557600080fd5b81356001600160e01b031981168114612f3957600080fd5b6001600160a01b03169052565b6001600160a01b0391909116815260200190565b801515811461111f57600080fd5b60006020828403121561315e57600080fd5b8135612f398161313e565b60006020828403121561317b57600080fd5b5035919050565b6000806040838503121561319557600080fd5b82356131a0816130c1565b915060208301356131b08161313e565b809150509250929050565b600080604083850312156131ce57600080fd5b8235915060208301356131b0816130c1565b600081518084526020808501945080840160005b838110156132195781516001600160a01b0316875295820195908201906001016131f4565b509495945050505050565b60208152600082516102408060208501526132436102608501836131e0565b91506020850151613257604086018261311d565b50604085015161326a606086018261311d565b50606085015161327d608086018261311d565b50608085015161329060a086018261311d565b5060a08501516132a360c086018261311d565b5060c08501516132b660e086018261311d565b5060e08501516101006132cb8187018361311d565b86015190506101206132df8682018361311d565b86015190506101406132f38682018361311d565b86015190506101606133078682018361311d565b860151905061018061331b8682018361311d565b86015190506101a061332f8682018361311d565b86015190506101c06133438682018361311d565b86015190506101e06133578682018361311d565b860151905061020061336b8682018361311d565b860151905061022061337f8682018361311d565b86015190506133908583018261311d565b5090949350505050565b634e487b7160e01b600052604160045260246000fd5b600080604083850312156133c357600080fd5b82356133ce816130c1565b915060208301356001600160401b03808211156133ea57600080fd5b818501915085601f8301126133fe57600080fd5b8135818111156134105761341061339a565b604051601f8201601f19908116603f011681019083821181831017156134385761343861339a565b8160405282815288602084870101111561345157600080fd5b8260208601602083013760006020848301015280955050505050509250929050565b634e487b7160e01b600052602160045260246000fd5b600c81106134a757634e487b7160e01b600052602160045260246000fd5b9052565b602080825282518282018190526000919060409081850190868401855b828110156134fd5781516134dd858251613489565b8601516001600160a01b03168487015292840192908501906001016134c8565b5091979650505050505050565b60208152600082516101608060208501526135296101808501836131e0565b9150602085015161353d604086018261311d565b506040850151613550606086018261311d565b506060850151613563608086018261311d565b50608085015161357660a086018261311d565b5060a085015161358960c086018261311d565b5060c085015161359c60e086018261311d565b5060e08501516101006135b18187018361311d565b86015190506101206135c58682018361311d565b860151905061014061337f8682018361311d565b60208152600082516102008060208501526135f86102208501836131e0565b9150602085015161360c604086018261311d565b50604085015161361f606086018261311d565b506060850151613632608086018261311d565b50608085015161364560a086018261311d565b5060a085015161365860c086018261311d565b5060c085015161366b60e086018261311d565b5060e08501516101006136808187018361311d565b86015190506101206136948682018361311d565b86015190506101406136a88682018361311d565b86015190506101606136bc8682018361311d565b86015190506101806136d08682018361311d565b86015190506101a06136e48682018361311d565b86015190506101c06136f88682018361311d565b86015190506101e061337f8682018361311d565b6040810161371a8285613489565b6001600160a01b039290921660209190910152919050565b6020808252602f908201526000805160206139e683398151915260408201526e3737ba1030b71037b832b930ba37b960891b606082015260800190565b6020808252602c90820152600080516020613a0683398151915260408201526b19195b1959d85d1958d85b1b60a21b606082015260800190565b6020808252602c90820152600080516020613a0683398151915260408201526b6163746976652070726f787960a01b606082015260800190565b6000602082840312156137f557600080fd5b8151612f39816130c1565b60006020828403121561381257600080fd5b8151612f398161313e565b60006020828403121561382f57600080fd5b5051919050565b60005b83811015613851578181015183820152602001613839565b50506000910152565b76020b1b1b2b9b9a1b7b73a3937b61d1030b1b1b7bab73a1604d1b81526000835161388c816017850160208801613836565b7001034b99036b4b9b9b4b733903937b6329607d1b60179184019182015283516138bd816028840160208801613836565b01602801949350505050565b60208152600082518060208401526138e8816040850160208701613836565b601f01601f19169190910160400192915050565b634e487b7160e01b600052601160045260246000fd5b8082028115828204841417610c0a57610c0a6138fc565b80820180821115610c0a57610c0a6138fc565b634e487b7160e01b600052603260045260246000fd5b600081613961576139616138fc565b506000190190565b6000825161397b818460208701613836565b919091019291505056fe24e583e35a20f9ecfc1572e7cb66bcc18ad3cd1650ec40dbf6ad2290e553a9fa2344277e405079ec07749d374ba0b5862a4e45a6a05ac889dbb4a991c6f9354d5f24b6aa970103905689bea2f5134d3056494b2888ee9123c61e926e0b213d8753657276696365436f6e66696775726174696f6e3a2063616c6c65722069732046756e6374696f6e206d7573742062652063616c6c6564207468726f75676820fc425f2263d0df187444b70e47283d622c70181c5baebb1306a01edba1ce184c360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc97667070c54ef182b0f5858b034beac1b6f3089aa2d3188bb1e8929f4fa9b92965d7a28e3265b37a6474929f336521b332c1681b933f6cb9f3376673440d862a416464726573733a206c6f772d6c6576656c2064656c65676174652063616c6c206661696c65648543e9adbfbe1f62b7411fdf032fcfea758a7d6b332f64d971a1334c2ff364dd85d36e3b488c35c2a15344b305cb84e2000f26d4f3a7c1e8a516f0e82aee752a380b61a03d510578eb69abac2609346d7bf838d9f340f7d0c66cfc65790d7f5fa2646970667358221220dfd4740a2a0080f805068670e82a70cd6296a9d9af714f38ac782ddce79af33764736f6c63430008130033",
  "deployedBytecode": "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",
  "linkReferences": {},
  "deployedLinkReferences": {}
}
